import React, { useState, useEffect } from 'react';
import './MovingAdvertisement.css';

const MovingAdvertisement = () => {
  const [pauseAnimation, setPauseAnimation] = useState(false);
  
  // Ads data - could be fetched from an API in a real implementation
  const advertisements = [
    { id: 1, icon: '🔥', text: 'Hot Deal: 25% OFF on all PCB prototyping services until June 30' },
    { id: 2, icon: '🚚', text: 'Free shipping on all orders above ₹1500 | Use code FREESHIP25' },
    { id: 3, icon: '🎁', text: 'Buy any Arduino board & get a Sensor Kit at half price' },
    { id: 4, icon: '🏆', text: 'Join our Makers Challenge and win exciting prizes worth ₹50,000' },
    { id: 5, icon: '🔔', text: 'New batch of Raspberry Pi 5 now in stock - Limited quantities!' },
    { id: 6, icon: '💡', text: 'Free workshop on IoT solutions every Saturday at our Bengaluru center' },
    { id: 7, icon: '🛠️', text: 'Same-day 3D printing & laser cutting services now available' },
    { id: 8, icon: '⚡', text: 'ProCart Pro membership: Earn 2X points on every purchase' }
  ];

  // Pause animation on hover
  const handleMouseEnter = () => setPauseAnimation(true);
  const handleMouseLeave = () => setPauseAnimation(false);

  return (
    <div 
      className={`dmh-advertisement-container ${pauseAnimation ? 'paused' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="dmh-advertisement-badge">
        PROCART
        <span className="dmh-advertisement-badge-subtitle">OFFERS</span>
      </div>
      
      <div className="dmh-advertisement-wrapper">
        <div className="dmh-moving-content">
          {/* First set of advertisements */}
          {advertisements.map(ad => (
            <div key={ad.id} className="dmh-ad-item">
              <div className="dmh-ad-icon">{ad.icon}</div>
              <div className="dmh-ad-text">{ad.text}</div>
            </div>
          ))}
          
          {/* Duplicate the advertisements for seamless looping */}
          {advertisements.map(ad => (
            <div key={`dup-${ad.id}`} className="dmh-ad-item">
              <div className="dmh-ad-icon">{ad.icon}</div>
              <div className="dmh-ad-text">{ad.text}</div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="dmh-advertisement-actions">
        <button className="dmh-view-all-btn">View All Offers</button>
      </div>
    </div>
  );
};

export default MovingAdvertisement;